import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {CREDIT_CARD_PAYMENT_METHODS, IMAGES_PATHS} from '../../../consts';
import CreditCardForm from '../../molecules/CreditCardForm';


const CreditCardPopup = ({
    translations,
    maskedCardNumber,
    onClose,
    isSubmitting,
    genericError,
    onSubmit,
    paymentMethod
}) => {
    useEffect(() => {
        document.getElementById('cvv-creditcard')?.focus();
    });

    return (
        <div className="popup-container">
            <button type="button" className="popup-background" onClick={onClose} tabIndex="-1" />
            <div className="popup-inner">
                <button onClick={onClose} type="button" className="popup-close">
                    <img
                        className="heading-with-icon-img"
                        src={IMAGES_PATHS.CLOSE}
                        alt="close"
                    />
                </button>

                <h2 className="popup-masked-pan">{maskedCardNumber}</h2>
                <h2>{translations.creditCard.popUp.heading}</h2>
                <h4>{translations.creditCard.popUp.cvv}</h4>

                <CreditCardForm
                    disableSubmitButton={Boolean(isSubmitting || genericError)}
                    translations={translations}
                    onSubmit={onSubmit}
                    genericError={genericError}
                    paymentMethod={paymentMethod}
                />
            </div>
        </div>
    );
};

CreditCardPopup.propTypes = {
    translations: PropTypes.shape({
        common: PropTypes.shape({
            continue: PropTypes.string.isRequired
        }),
        creditCard: PropTypes.shape({
            popUp: PropTypes.shape({
                heading: PropTypes.string.isRequired,
                warningText: PropTypes.string.isRequired,
                cvv: PropTypes.string.isRequired
            })
        }),
        cybersource: PropTypes.shape({
            errors: PropTypes.shape({
                securityCode: PropTypes.shape({
                    required: PropTypes.string.isRequired,
                    invalid: PropTypes.string.isRequired
                })
            })
        }),
        zepz: PropTypes.shape({
            errors: PropTypes.shape({
                securityCode: PropTypes.shape({
                    required: PropTypes.string.isRequired,
                    format: PropTypes.string.isRequired
                })
            })
        })
    }).isRequired,
    maskedCardNumber: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    genericError: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    paymentMethod: PropTypes.oneOf([
        CREDIT_CARD_PAYMENT_METHODS.CYBERSOURCE,
        CREDIT_CARD_PAYMENT_METHODS.ZEPZ
    ]).isRequired
};

export default CreditCardPopup;
